import { createRouter, createWebHistory } from "vue-router";
import ItemDetails from "../views/ItemDetails.vue";
import ItemsList from "../views/ItemsList.vue";
import DelivererDashboard from "@/views/DelivererDashboard.vue";
import AvailableItems from "@/views/AvailableItems.vue";
import ItemDetail from "@/views/ItemDetail.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/signup",
    name: "Signup",
    component: () => import("../views/Signup.vue"),
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: () => import("../views/ForgotPassword.vue"),
  },
  {
    path: "/verify-email",
    name: "VerifyEmail",
    component: () => import("../views/VerifyEmail.vue"),
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: () => import("../views/ResetPassword.vue"),
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("../views/Dashboard.vue"),
    meta: {
      requiresAuth: true,
      role: "sender",
    },
  },
  {
    path: "/post-item",
    name: "PostItem",
    component: () => import("../views/PostItem.vue"),
    meta: {
      requiresAuth: true,
      role: "sender",
    },
  },
  {
    path: "/items/:id",
    name: "ItemDetails",
    component: ItemDetails,
    meta: { requiresAuth: true, role: "sender" },
  },
  {
    path: "/items",
    name: "ItemsList",
    component: ItemsList,
    meta: { requiresAuth: true, role: "sender" },
  },
  {
    path: "/deliverer-dashboard",
    name: "DelivererDashboard",
    component: DelivererDashboard,
    meta: {
      requiresAuth: true,
      role: "deliverer",
    },
  },
  {
    path: "/available-items",
    name: "AvailableItems",
    component: AvailableItems,
    meta: {
      requiresAuth: true,
      role: "deliverer",
    },
  },
  {
    path: "/available-items/:id",
    name: "ItemDetail",
    component: ItemDetail,
    meta: {
      requiresAuth: true,
      role: "deliverer",
    },
  },
  {
    path: "/my-deliveries",
    name: "MyDeliveries",
    component: () => import("../views/MyDeliveries.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/my-deliveries/:id",
    name: "DeliveryItemDetail",
    component: () => import("../views/DeliveryItemDetail.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/rejected-requests",
    name: "RejectedRequests",
    component: () => import("../views/RejectedRequests.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/payment-method",
    name: "PaymentMethod",
    component: () => import("../views/PaymentMethod.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/profile",
    name: "ProfileSettings",
    component: () => import("../views/ProfileSettings.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/how-it-works",
    name: "HowItWorks",
    component: () => import("../views/HowItWorks.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/faq",
    name: "FAQ",
    component: () => import("../views/FAQ.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: () => import("../views/Privacy.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/terms",
    name: "TermsOfService",
    component: () => import("../views/TermsOfService.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/contact",
    name: "ContactUs",
    component: () => import("../views/ContactUs.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/about",
    name: "About",
    component: () => import("../views/About.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/admin-dashboard",
    name: "AdminDashboard",
    component: () => import("../views/AdminDashboard.vue"),
    meta: { requiresAuth: true, role: "admin" },
  },
  {
    path: "/users",
    name: "UsersPage",
    component: () => import("../views/AdminDashboard/UsersPage.vue"),
    meta: { requiresAuth: true, role: "admin" },
  },
  {
    path: "/items-management",
    name: "ItemsManagement",
    component: () => import("../views/AdminDashboard/ItemsManagement.vue"),
    meta: { requiresAuth: true, role: "admin" },
  },
  {
    path: "/sending-approval/item/:id",
    name: "ItemSendingApproval",
    component: () => import("../components/ItemSendingApproval.vue"),
    meta: { requiresAuth: true, role: "admin" },
  },
  // {
  //   path: "/delivery-approval/item/:id",
  //   name: "ItemDeliveryApproval",
  //   component: () => import("../components/ItemDeliveryApproval.vue"),
  //   meta: { requiresAuth: true, role: "admin" },
  // },
  {
    path: "/set-password",
    component: () => import("../views/AdminDashboard/SetPassword.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/agreements",
    name: "ConsentScreensPage",
    component: () => import("../views/AdminDashboard/ConsentScreens.vue"),
    meta: { requiresAuth: false, role: "admin" },
  },

  // {
  //   path: "/orders-deliveries",
  //   name: "OrdersDeliveries",
  //   component: () => import("../views/AdminDashboard/OrdersDeliveries.vue"),
  //   // meta: { requiresAuth: false }
  // },
  // {
  //   path: "/pyments-mangement",
  //   name: "PaymentsManagement",
  //   component: () => import("../views/AdminDashboard/PaymentsManagement.vue"),
  //   // meta: { requiresAuth: false }
  // },
  // {
  //   path: "/reports-analytics",
  //   name: "ReportsAnalytics",
  //   component: () => import("../views/AdminDashboard/ReportsAnalytics.vue"),
  //   // meta: { requiresAuth: false }
  // },
  // {
  //   path: "/reviews-feedback",
  //   name: "ReviewsFeedback",
  //   component: () => import("../views/AdminDashboard/ReviewsFeedback.vue"),
  //   // meta: { requiresAuth: false }
  // },
  // {
  //   path: "/settings",
  //   name: "SettingsPage",
  //   component: () => import("../views/AdminDashboard/SettingsPage.vue"),
  //   // meta: { requiresAuth: false }
  // },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  if (requiresAuth && !token) {
    next("/login");
  } else if (requiresAuth && to.meta.role && to.meta.role !== user.role) {
    if (user.role === "deliverer") {
      next("/deliverer-dashboard");
    } else if (user.role === "admin") {
      next("/admin-dashboard");
    } else {
      next("/dashboard");
    }
  } else {
    next();
  }
});

export default router;
